import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import DateDropdown from "@/components/DateDropdown";
import { REM_CONFIG } from "@/utils/fontSize";
import moment from "moment";
const ProjectBudgetComparison = ({ className = "", initDate = moment().format("YYYY-MM"), }) => {
    const [selectedDate, setSelectedDate] = useState(initDate);
    const [chartData, setChartData] = useState({
        amount: [24789.22, 167.62, 0, 0, 117.51],
        count: [1201, 22, 0, 0, 46],
    });
    const mockFetchData = (time) => {
        setChartData({
            amount: [24789.22, 167.62, 0, 0, 117.51],
            count: [1201, 22, 0, 0, 46],
        });
    };
    useEffect(() => {
        mockFetchData(selectedDate);
    }, []);
    // ECharts 核心配置（终极修复）
    const getChartOption = () => ({
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "cross" },
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: {
                color: "#fff",
            },
        },
        legend: {
            data: ["金额", "数量"],
            textStyle: { color: "#ffffff", fontSize: REM_CONFIG.fontSize.small }, // 文字大小统一
            orient: "horizontal",
            left: "center",
            top: 8, // 与 Y 轴名称同高度（关键！）
            itemGap: 20,
        },
        xAxis: {
            type: "category",
            data: ["在用", "闲置", "技改", "停用", "待报废"],
            axisLabel: {
                color: "#ffffff",
                fontSize: REM_CONFIG.fontSize.small,
                interval: 0,
            },
        },
        yAxis: [
            {
                type: "value",
                name: "金额（万元）",
                nameTextStyle: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                nameLocation: "end",
                axisLabel: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" }, // 网格线浅灰透明
                },
            },
            {
                type: "value",
                name: "数量（项）",
                nameTextStyle: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                axisLabel: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                splitLine: { show: false },
            },
        ],
        series: [
            {
                name: "金额",
                type: "bar",
                data: chartData.amount,
                barWidth: "16%", // 修正：百分比单位，避免宽度异常
                itemStyle: {
                    barBorderRadius: [8, 8, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#2F96E2" },
                        { offset: 1, color: "#1A659B" },
                    ]),
                },
            },
            {
                name: "数量",
                type: "line",
                yAxisIndex: 1,
                data: chartData.count,
                itemStyle: { color: "#60FFFF" },
                symbol: "circle",
                symbolSize: 8, // 圆点大小优化
                smooth: true,
                lineStyle: { width: 2 }, // 线项加粗
            },
        ],
        // 🔴 网格：提升内容区高度 + 完美预留空间
        grid: {
            left: "2%", // 修正：百分比单位
            right: "2%", // 修正：百分比单位
            bottom: "2%", // 修正：百分比单位，提升底部高度
            top: 60, // 增大顶部间距，容纳图例和 Y 轴名称
            containLabel: true,
        },
    });
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
        flex flex-col 
        ${className}
        min-h-0
      `, children: [_jsx(ModuleHeader, { title: "\u8D44\u4EA7\u72B6\u6001\u5360\u6BD4-\u56FA\u5B9A\u8D44\u4EA7", children: _jsx(DateDropdown, { initDate: initDate, onDateChange: (date) => mockFetchData(date) }) }), _jsx("div", { className: "flex-1 min-h-0", children: _jsx(ReactEcharts, { option: getChartOption(), style: { width: "100%", height: "100%" }, echarts: echarts }) })] }));
};
export default ProjectBudgetComparison;
